@if (isPanicButtonEnabled && m2User.isAuthenticated) {
    <div class="panic-button-container">
        <div class="panic-text">
            <div class="panic-heading">
                <span>{{ sitecore.panicButtonMessages.PanicButtonDesktopHeader }}</span>
            </div>
            <div>
                <span>{{ sitecore.panicButtonMessages.PanicButtonDesktopText }}</span>
            </div>
        </div>
        <button
            ds-button
            kind="secondary"
            variant="filled"
            size="large"
            msThemedButton
            [inverse]="false"
            [themeInverse]="buttonThemeInverse"
            (click)="onPanicClick()">
            {{ sitecore.panicButtonMessages.PanicButtonActivateNow }}
            <vn-icon slot="start" name="theme-hand-icon"></vn-icon>
        </button>
    </div>
}
